/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AdmitStorefrontLoginEntryRequest} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'
import {AdmitStorefrontLoginEntryResponse} from '@cash-web/protos/squareup/cash/local/v1/cash_app_local_web_service.pb'


export const admitStorefrontLoginEntry = (request: AdmitStorefrontLoginEntryRequest, options?: CashRequestOptions) => post<AdmitStorefrontLoginEntryRequest, AdmitStorefrontLoginEntryResponse>("/2.0/cash/admit-storefront-login-entry", request, {...options, rejectOnError: true })